export class Errors {

    rowId: number;
    message: string;
    type?: number;

    constructor() {
    }
}